import { useDispatch as useReduxDispatch } from 'react-redux';

import { TD } from '../../store/types.js';

export default function useDispatch(): TD {
    return useReduxDispatch<TD>();
}
